<ng-container *ngIf="!teamSquadService.loading">
  <ng-container *ngFor="let playerGroup of teamSquadService.squadPlayersGrouped">
    <div class="mb-2" *ngIf="playerGroup.objects.length > 0">
      <span class=title>{{playerGroup.position}}</span>
      <div class="player__cards-wrapper">
        <div *ngFor="let player of playerGroup.objects" class="player__card">
          <app-player-card [player]="player"></app-player-card>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<mat-spinner *ngIf="teamSquadService.loading"
             style="margin: 24px auto"
             strokeWidth="1" diameter="63" color="primary"></mat-spinner>
<p class="no-infos-available"
   *ngIf="!teamSquadService.loading && !hasPlayers()">Keine Spieler eingetragen</p>
